/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermitDisplayComponent } from "cms/components/permit-display";
// import { useFetchPermit } from "cms/hooks/use-fetch-permit";
// import { searchAddress } from "cms/hooks/mock/use-fetch-permit.enum";
// import { PublicSearch } from "cms/components/permit-display/public-search";

const PublicPermits = () => {
    // const filter = {};
    // const { permits, fetchPublicPermitData } = useFetchPermit(filter);
    // const [publicPermits, setPublicPermits] = useState(permits);
    // const [fullSearchFilter, setFullSearchFilter] = useState({});
    //
    const mockComponentData = {
        show_summary: true,
        show_header: true,
        show_filter: true,
        type: "housing",
    };
    //
    // const publicPermitSearchHandler = async () => {
    //     const permits = await fetchPublicPermitData(fullSearchFilter);
    //     setPublicPermits(permits);
    // };
    //
    // const buildPermitQuery = async (value) => {
    //     setFullSearchFilter({ value });
    //     const address = await searchAddress(value);
    //     return address;
    // };
    //
    // useEffect(() => {
    //     setPublicPermits(permits);
    // }, [permits]);

    // TODO: This is just for testing. PermitDisplayComponent is a SimpliCity Component
    //       SimpliCity Components are not used directly like regular react components

    return (
        <main className="public-permits-wrapper">
            <PermitDisplayComponent
                component={mockComponentData}
                // permits={publicPermits}
                // onChangeHandler={buildPermitQuery}
                // onSearchHandler={publicPermitSearchHandler}
                // SearchFilterComp={PublicSearch}
            />
        </main>
    );
};

export { PublicPermits };
